import { gql } from "@apollo/client";

export const GET_STUDENTS = gql`
  query GetStudentsResolver {
    getStudentsResolver {
      _id
      fullName
      dni
      nationality
      gender
      birthDay
      email
      medicalRecord
      createdAt
      status
      phoneNumbers {
        phoneNumber
      }
      addressInfo {
        street
        cp
        city
      }
    }
  }
`;

// SUPERSEDED by src/graphql/query/Fees.js — GET_OVERDUE_STUDENTS for the
// mora column and GET_STUDENTS_COURSES for the export. This one derived
// cuotas from `moves`, so a student who had never paid appeared to owe
// nothing and to be enrolled in nothing.
// export const GET_STUDENTS_FEES = gql`
//   query getStudentsFeesResolver {
//     getStudentsFeesResolver {
//       _id
//       student {
//         _id
//         courses {
//           turnId
//           name
//           courseName
//           amountOfFees
//           startDate
//           moves {
//             feeDetail {
//               fees {
//                 feeNumber
//                 value
//               }
//             }
//           }
//         }
//       }
//     }
//   }
// `;

export const GET_STUDENT_COURSES = gql`
  query getCoursesByStudentIdResolver($studentId: String) {
    getCoursesByStudentIdResolver(studentId: $studentId) {
      _id
      courseInfo {
        _id
        name
        description
        category
        duration
        createdAt
        status
      }
      turnInfo {
        _id
        name
        cost {
          amountOfFees
          inscription
          total
        }
        startDate
        finishDate
        schedule {
          day
          startTime
          endTime
          classroomId
        }
      }
    }
  }
`;

export const GET_STUDENT_INFO = gql`
  query getStudentInformationResolver($studentId: String) {
    getStudentInformationResolver(studentId: $studentId)
  }
`;

export const GET_STUDENTS_ENROLLMENTS = gql`
  query getStudentReportResolver(
    $studentId: String
    $dateFrom: Float
    $dateTo: Float
    $category: String
    $courseId: String
  ) {
    getStudentReportResolver(
      studentId: $studentId
      dateFrom: $dateFrom
      dateTo: $dateTo
      category: $category
      courseId: $courseId
    )
  }
`;

export const SEARCH_STUDENTS = gql`
  query SearchStudentsResolver(
    $query: String
    $page: Int
    $limit: Int
    $status: String
  ) {
    searchStudentsResolver(
      query: $query
      page: $page
      limit: $limit
      status: $status
    ) {
      students {
        _id
        fullName
        dni
        nationality
        gender
        birthDay
        email
        medicalRecord
        createdAt
        status
        phoneNumbers {
          phoneNumber
        }
        addressInfo {
          street
          cp
          city
        }
      }
      pagination {
        totalItems
        currentPage
        totalPages
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;
